export default __webpack_public_path__ + "media/images/logo-small-5760fa8565a4646fb5f9567bca70189b.svg";